// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  padding: 8px;
}
.container ion-header {
  flex-grow: 0;
}
.container ion-title {
  font-size: 17px !important;
}
.container .iframe-popover-container {
  flex-grow: 1;
  display: flex;
  overflow: hidden;
}
.container .iframe-popover-container::part(scroll) {
  overflow-y: hidden;
}
.container .iframe-popover-container iframe {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-iframe/popover-iframe.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;AACJ;AACE;EACE,0BAAA;AACJ;AAIE;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AAFJ;AAII;EACE,kBAAA;AAFN;AAKI;EACE,YAAA;AAHN","sourcesContent":[".container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  overflow: hidden;\r\n  padding: 8px;\r\n\r\n  ion-header  {\r\n    flex-grow: 0;\r\n  }\r\n  ion-title  {\r\n    font-size: 17px !important;\r\n  }\r\n  @media (orientation: landscape) and (min-width: 768px)  {\r\n    // padding-top: 100px !important;\r\n  }\r\n  .iframe-popover-container {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    overflow: hidden;\r\n\r\n    &::part(scroll) {\r\n      overflow-y: hidden;\r\n    }\r\n\r\n    iframe {\r\n      flex-grow: 1;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
